import React, { useEffect, useLayoutEffect } from 'react';
import { AppView, withAnimatedNavigationHeader } from 'design-system';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { getGroups } from 'actions';
import { useAppDispatch } from 'store/hooks';
import GroupsList from './components/GroupsList';
/**
 * Web version of the groups list. The app loads the groups when it starts; web
 * loads them with the feed, and the list can be opened straight from its URL or
 * the sidebar, so it fetches them itself.
 */
const GroupsListScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getGroups());
    }, [dispatch]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, [navigation]);
    return (<AppView withFrame={false}>
          <GroupsList onScroll={scrollHandler}/>
        </AppView>);
}, { title: 'Groups' });
export default GroupsListScreen;
